import { AvailabilityState } from './types';

const state = (): AvailabilityState => {
  return {
    availabilities: [],
  };
};

export default state;
